
const baseData = {
	// （-1-新数据未处理 0-待跟进 1-待签约 2-已上门 3-已签约 4-已放款 5-未分配 6-审件中 7-办理中 8-已邀约）
	customerStatus :[
		{label:'新数据未处理',value:-1}, //分配之后流转
		{label:'待跟进',value:0}, // 修改星级大于0星之后流转
		{label:'待签约',value:1}, // 客户扫码等级提交之后流转
		{label:'已上门',value:2}, // 根据日志状态流转
		{label:'已签约',value:3}, // 添加业绩之后就是已放款
		{label:'已放款',value:4}, 
		// {label:'未分配',value:5},
		{label:'审件中',value:6},
		// {label:'办理中',value:7},
		// {label:'已邀约',value:8},
		// -1-新数据未处理 0-待跟进 1-待签约 2-已上门 3已签约 4已放款 5未分配 6审件中 7办理中 8已邀约
	],
	// 星级列表
	starRating:[
		{label:'0星',value:0},
		{label:'1星',value:1},
		{label:'2星',value:2},
		{label:'3星',value:3},
		{label:'4星',value:4},
		{label:'无效数据',value:-1},
	],
	effectiveStarRating:[
		{label:'0星',value:0},
		{label:'1星',value:1},
		{label:'2星',value:2},
		{label:'3星',value:3},
		{label:'4星',value:4},
	],
	// 跟进次数选择
	followUpState:[
		{label:'小于',value:0},
		{label:'小于等于',value:1},
		{label:'等于',value:2},
		{label:'大于等于',value:3},
		{label:'大于',value:4},
	],
	// 每页条数
	// pageSizeOptions:['10','15','20','30','50','100','200','300','400','500'],
	pageSizeOptions:['15','50','100','200','500'],
	pushStatusData:[
		{label:'未推送',value:0},
		{label:'推送中',value:1},
		// {label:'成功',value:2},
		// {label:'失败',value:3},
	],
	AptitudeList:[
		{label:'房',value:0},
		{label:'车',value:1},
		{label:'社保',value:2},
		{label:'公积金',value:4},
		{label:'企业',value:5},
		{label:'收入',value:6},
		{label:'保单',value:7},
	],
	// 在职状态列表 在职状态：0待面试 1未通过 2试岗 3实习 4面试通过待办理 5在职 6离职 7离职待审核
	employmentStatus:[
		{label:'已面试',value:0},
		{label:'未通过',value:1},
		{label:'试岗',value:2},
		{label:'实习',value:3},
		{label:'面试通过待入职',value:4},
		{label:'在职',value:5},
		{label:'离职',value:6},
		{label:'离职待审核',value:7},
	],
	// 类型 0-放款 1-签单 2-晋升 3-转正
	goodNewsType:[
		{label:'放款',value:0},
		{label:'签单',value:2},
		{label:'晋升',value:3},
		{label:'转正',value:4},
	],
	upDoorConclusion:[
		{label:'未签约',value:0},
		{label:'已签约',value:1},
		{label:'已上门',value:2},
		// {label:'介绍客户',value:2},
	],
	// 合同进展
	// 合同进展 0-待签约 1-已签约 2-已失效
	contractprogress:[
		{label:'待签约',value:0,color:'blue'},
		{label:'已签约',value:1,color:'rgb(36,172,62)'},
		{label:'已失效',value:2,color:'red'},
	],
	// 合同类型
	// 合同类型 0-抵押合同 1-信贷合同
	contractType:[
		{label:'抵押合同',value:0},
		{label:'信贷合同',value:1},
	],
	// 短信类型
	smstypeList:[],
	// 短信验证状态：0-等待结果 10-接受成功 20-接收失败
	receiveStatus:[
		{label:'等待结果',value:0},
		{label:'接受成功',value:10},
		{label:'接收失败',value:20},
	],
	// 短信类型
	// 1：验证码 2：通知 3：营销
	smsType:[
		{label:'验证码',value:1},
		{label:'通知',value:2},
		{label:'营销',value:3},
	],
	// 
	colorLists:[
		{key: '橙色', color: '#E85827'},
		{key: '蓝色', color: '#2C62C4'},
		{key: '深蓝', color: '#002EA6'},
		{key: '绿色', color: '#7FA91F'},
		{key: '火焰红', color: '#C8161D'},
		{key: '橙色', color: '#800020'}, 
		{key: '橙色', color: '#003153'}, 
		{key: '橙色', color: '#008C8C'}, 
	],
	// 无效理由 failure  无效理由 0-停机 1-空号 2-没来过上海 3-未申请过
	invalidReasonList:[
		{label:'停机',value:0},
		{label:'空号',value:1},
		{label:'没来过上海',value:2},
		{label:'未申请过',value:3},
	],
	// 是否异常 0-正常 1-差评 2-疑似差评
	exceptionList:[
		{label:'正常',value:0},
		{label:'差评',value:1},
		{label:'疑似差评',value:2},
	],
	// 电子合同变量内容
	variableList:[
		{title:'合同类型',label:'contractType',value:'$ContractType'},
		{title:'业务经理',label:'userName',value:'$userName'},
		{title:'客户名称',label:'partyAName',value:'$partyAName'},
		{title:'诚意金',label:'sincerityMoney',value:'$sincerityMoney'},
		{title:'诚意金大写',label:'goodFaith',value:'$goodFaith'},
		{title:'身份证号码',label:'idCardNo',value:'$idCardNo'},
		{title:'违约金',label:'damagesMoney',value:'$damagesMoney'},
		{title:'联系电话',label:'concatMobile',value:'$concatMobile'},
		{title:'服务费',label:'pointRabit',value:'$pointRabit'},
		{title:'现居地址',label:'address',value:'$address'},
		{title:'申请金额',label:'quota',value:'$quota'},
		{title:'申请金额大写',label:'amountWords',value:'$amountWords'},
	],
	// 视频类型
	videoTypeList:[
		{label:'车辆抵押确认',value:0},
		{label:'房屋抵押确认',value:1},
		{label:'合同权益与费用确认',value:2},
	],
	// 视频话术模板变量
	videoScriptVariableList:[
		{title:'客户姓名',label:'customerName',value:'#customerName#'},
		{title:'客户身份证号',label:'idNumber',value:'#idNumber#'},
		{title:'签署时间（当前时间）',label:'videoData',value:'#videoData#'},
		{title:'公司名称',label:'companyName',value:'#companyName#'},
		{title:'费用点',label:'feePoint',value:'#feePoint#'},
		{title:'代支付人',label:'replaceName',value:'#replaceName#'},
		{title:'代支付人身份证号',label:'replaceIdCardNo',value:'#replaceIdCardNo#'},
	]
}

module.exports = baseData